import React, { useState } from 'react';
import CreateFolderModal from './CreateFolderModal';
const meta = {
    title: 'Features/CustomerFileDrop/CreateFolderModal',
    tags: ['autodocs'],
    parameters: { layout: 'centered' }
};
export default meta;
export const Open = {
    args: { isOpen: true },
    render: (args) => {
        const [open, setOpen] = useState(args.isOpen);
        return (React.createElement(CreateFolderModal, { isOpen: open, onClose: () => setOpen(false), onCreated: () => setOpen(false) }));
    }
};
export const ClosedWithTrigger = {
    render: () => {
        const [open, setOpen] = useState(false);
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { type: "button", onClick: () => setOpen(true) }, "Open create folder"),
            React.createElement(CreateFolderModal, { isOpen: open, onClose: () => setOpen(false), onCreated: () => setOpen(false) })));
    }
};
